// removed by extract-text-webpack-plugin
module.exports = {"root":"Interaction__root___1YSfX","heading":"Interaction__heading___1jml1","list":"Interaction__list___3zYFv","card":"Interaction__card___22y4V"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/interaction/Interaction.scss
// module id = 845
// module chunks = 0